import { ConfirmDialog } from "./confirm-dialog";

type ConfirmChangePasswordAlertProps = {
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean;
};

export const ConfirmChangePasswordAlert = ({
  isOpen,
  onClose,
  onConfirm,
}: ConfirmChangePasswordAlertProps) => {
  return (
    <ConfirmDialog
      cancelLabel="Nevermind"
      confirmLabel="Change password"
      description="You will use your new password the next time you sign in."
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Change your password?"
    />
  );
};
